import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient, { publicApiClient } from '@/core/api/client'
import { UserResponseDTO } from '@/core/api/dtos/response/users/user'

import { ChangePasswordRequestDTO } from '@core/api/dtos/request/users/changePassword'
import { EmailAvailabilityRequestDTO } from '@core/api/dtos/request/users/emailAvailability'
import { UpdateUserRequestDTO } from '@core/api/dtos/request/users/updateUser'
import { UserLoginTokenResponseDTO } from '@core/api/dtos/response/users/userLoginToken'

export const userService = {
	/**
	 * Get the current user profile
	 */
	getCurrentUser(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return publicApiClient.get('/users/me', config)
	},

	/**
	 * Check if an email is available
	 */
	checkEmailAvailability(
		data: EmailAvailabilityRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.post('/self/register/available', data, config)
	},

	/**
	 * Change user password
	 */
	changePassword(
		data: ChangePasswordRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.patch('/users/password', data, config)
	},

	/**
	 * Update user profile
	 */
	updateUser(
		userId: number,
		data: UpdateUserRequestDTO,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse<{ data: UserResponseDTO }>> {
		return apiClient.patch(`/users/${userId}`, data, config)
	},

	/**
	 * Get login token for a user (for login as user feature)
	 */
	getUserLoginToken(
		userId: number,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse<{ data: UserLoginTokenResponseDTO }>> {
		return apiClient.get(`/users/${userId}/token`, config)
	},

	/**
	 * Disable a user
	 */
	disableUser(
		userId: number,
		config?: AxiosRequestConfig
	): Promise<AxiosResponse> {
		return apiClient.patch(`/users/${userId}/disable`, {}, config)
	},

	/**
	 * Get my users
	 */
	getMyUsers(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/my/users', config)
	},
}

export default userService
